import LegalLayout from "./LegalLayout";

const sections = [
  {
    heading: "Agreement",
    paragraphs: [
      "By purchasing or accessing the BuildOnce Clarity Kit, you agree to be bound by these Terms and Conditions. Please read them carefully before completing your purchase. If you do not agree to these terms, do not proceed with the purchase.",
      "These Terms and Conditions constitute a legally binding agreement between you (the purchaser/user) and BuildOnce Studio (UEN: 53518159X), a sole proprietorship registered in Singapore and operated by Jophy Orenza.",
    ],
  },
  {
    heading: "The product",
    paragraphs: [
      "The BuildOnce Clarity Kit is a self-guided, digital decision-making tool designed to help founders and independent consultants gain clarity on business priorities, positioning, and direction. It includes:",
    ],
    bullets: [
      "Six guided decision-making exercises delivered via a digital interface at buildoncestudio.com/clarity-kit.",
      "An AI thinking partner powered by Anthropic's Claude, which provides reflections based on your inputs.",
      "A PDF workbook companion for offline use.",
      "Seven editable templates for key outputs.",
      "Access to supporting resources as described on the product page at the time of purchase.",
    ],
    note: "Important: The Clarity Kit is a self-guided thinking tool. It does not constitute strategic, financial, legal, or professional advisory services. Results depend on the quality and honesty of your inputs and your subsequent application of the outputs.",
  },
  {
    heading: "Access and delivery",
    paragraphs: [
      "Upon successful payment, you will receive access to the Clarity Kit. Access is granted to the individual purchaser only and is non-transferable.",
    ],
    bullets: [
      "Access is delivered digitally and is available immediately upon payment confirmation.",
      "You are responsible for ensuring your email address is entered correctly at checkout.",
      "If you do not receive access within 24 hours of purchase, contact info@buildoncestudio.com and we will resolve your access manually within one business day.",
      "Your access link remains valid for 12 months from the date of purchase.",
    ],
  },
  {
    heading: "Refund policy",
    paragraphs: [
      "**No refunds once accessed:** No refunds will be issued once the Clarity Kit has been accessed. By clicking your access link, you acknowledge that delivery of the digital product is complete. This policy is consistent with the Consumer Protection (Fair Trading) Act (Singapore) as it applies to digital goods accessed immediately upon delivery.",
      "Exceptions are considered at BuildOnce Studio's sole discretion in cases of genuine technical failure where the product is inaccessible through no fault of the purchaser. To request a review, email info@buildoncestudio.com within 7 days of purchase with a description of the technical issue.",
    ],
  },
  {
    heading: "Intellectual property",
    paragraphs: [
      "All content within the Clarity Kit is the intellectual property of BuildOnce Studio and Jophy Orenza.",
    ],
    bullets: [
      "You are granted a personal, non-exclusive, non-transferable licence to use the Clarity Kit for your own business decision-making purposes.",
      "You may not reproduce, share, resell, sublicense, or create derivative works from any part of the Clarity Kit.",
      "You may not use the content of the Clarity Kit to create a competing product or service.",
      "Sharing your access link with a third party is a breach of these Terms.",
    ],
    note: "BuildOnce Studio reserves the right to revoke access in the event of a breach of these intellectual property terms without refund.",
  },
  {
    heading: "AI capability, limitations and disclaimer",
    paragraphs: [
      "The Clarity Kit includes an AI thinking partner powered by Anthropic's Claude. By using this feature, you acknowledge and agree to the following:",
    ],
    bullets: [
      "AI responses are generated automatically based on your inputs. They are informational and reflective in nature.",
      "AI responses do not constitute financial, legal, marketing, tax, or professional advisory services of any kind.",
      "BuildOnce Studio does not verify, guarantee, or warrant the accuracy, completeness, or fitness for purpose of any AI-generated response.",
      "You are solely responsible for evaluating and applying any AI-generated content to your own business context.",
      "Anthropic processes your inputs under their own Terms of Service and Privacy Policy at anthropic.com.",
      "BuildOnce Studio is not liable for any decision made in reliance on AI-generated responses.",
    ],
  },
  {
    heading: "Limitation of liability",
    paragraphs: [
      "To the maximum extent permitted by Singapore law, BuildOnce Studio shall not be liable for any indirect, incidental, special, or consequential loss arising from your use of the Clarity Kit. BuildOnce Studio's total liability shall not exceed the amount you paid for the product (SGD 97 or SGD 149, as applicable).",
    ],
  },
  {
    heading: "Governing law",
    paragraphs: [
      "These Terms and Conditions are governed by the laws of Singapore. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the Singapore courts.",
    ],
  },
  {
    heading: "Amendments",
    paragraphs: [
      "BuildOnce Studio reserves the right to update these Terms and Conditions at any time. Continued use of the product after an update constitutes acceptance of the revised terms.",
    ],
  },
  {
    heading: "Contact",
    paragraphs: [
      "BuildOnce Studio · Jophy Orenza · info@buildoncestudio.com · buildoncestudio.com · UEN: 53518159X · Singapore",
    ],
  },
];

export default function TermsAndConditions() {
  return (
    <LegalLayout
      testId="terms-and-conditions-page"
      eyebrow="Legal · Terms"
      title="Terms and Conditions."
      intro="Your agreement with BuildOnce Studio for use of the Clarity Kit and related services."
      sections={sections}
    />
  );
}
